const CATEGORY_DATA = [
  {
    key: "Account",
    value: 1,
    text: "用户"
  },
  {
    key: "Unit",
    value: 2,
    text: "部门"
  },
  {
    key: "Maillist",
    value: 3,
    text: "邮件列表"
  },
  {
    key: "Group",
    value: 4,
    text: "公共联系人分组"
  },
  {
    key: "PubAddress",
    value: 5,
    text: "公共联系人"
  }
];
const CATEGORY = {};
const CATEGORY_TEXT = {};
for (let item of CATEGORY_DATA) {
  CATEGORY[item.key] = item.value;
  CATEGORY_TEXT[item.value] = item.text;
}
export { CATEGORY, CATEGORY_TEXT };
